export default "__VITE_ASSET__1ddd2045__"